import React, { useState, Fragment } from "react";
import {
    Box,
    Button,
    TableCell,
    TableRow,
    IconButton,
    Tooltip,
} from "@mui/material";
import CreateIcon from "@mui/icons-material/Create";

import { useNavigate } from "react-router-dom";
import qs from "qs";
import { useSelector } from "react-redux";

import LibraryLayout from "../library-layout";
import PageTitle from "../../../../hooks/page-title";
import API from "../../../../axios";
import {
    SelectBox,
    InputField,
    AddProjectBtn,
    CustomModal,
    UsePagination,
    TableWrapper,
    OrderDataBtn,
    MultiSelect,
    FilterWrapper
} from "../../../../components";
import TemplateForm from "./template-form";

export default function ProjectTemplatePanel() {
    PageTitle('Project Template');
    const [openModal, setOpenModal] = React.useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [records, setRecords] = useState(null);
    // filters
    const [page, setPage] = useState(1);
    const [columns, setColumns] = React.useState(_columns);
    const [perPage, setPerPage] = useState(25);
    const [search, setSearch] = useState("");
    const [language, setLanguage] = useState("");
    const [technologies, setTechnologies] = useState('');
    const [orderBy, setOrderBy] = useState({
        name: "created_at",
        order: "desc",
    });
    const [IsFilterApply, setIsFilterApply] = React.useState(false);
    const [toggler, setToggler] = React.useState(false);
    const _userRole = useSelector((state) => state.storeReducer.user.role);
    const navigate = useNavigate();

    React.useEffect(() => {
        getData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page, orderBy, perPage]);

    // get project records from db
    const getData = async (flush = false) => {
        setIsLoading(true);
        try {
            var params;
            if (flush) {
                params = {
                    page: page,
                    per_page: perPage,
                    column: 'created_at',
                    orderby: 'desc',
                };
            } else {
                params = {
                    page: page,
                    per_page: perPage,
                    search: search,
                    battery_storage: technologies === 'battery_storage' ? 1 : 0,
                    energy_management: technologies === 'energy_management' ? 1 : 0,
                    photovoltaic: technologies === 'photovoltaic' ? 1 : 0,
                    language: language,
                    column: orderBy.name,
                    orderby: orderBy.order,
                };
            }
            let { data } = await API(`${_userRole}/project-templates?` + qs.stringify(params), "get");
            setRecords(data);
            setIsLoading(false);
        } catch (error) {
            if (!!records) setRecords(null);
            setIsLoading(false);
        }
    };

    const applyFilters = () => {
        setIsFilterApply(true);
        getData();
    };

    const clearFilters = () => {
        setIsFilterApply(false);
        if (search !== "") {
            setSearch("");
        }
        if (language !== "") {
            setLanguage("");
        }
        if (technologies !== "") {
            setTechnologies("");
        }

        if (orderBy.name !== "created_at" && orderBy.order !== "desc") {
            setOrderBy({
                name: "created_at",
                order: "desc",
            });
        }
        getData(true);
    };

    const myFilters = () => {
        return (
            <>
                <InputField
                    size="small"
                    label="Search"
                    fullWidth
                    handleChange={(e) => setSearch(e.target.value)}
                    initValue={search}
                />
                <SelectBox
                    items={techOptions}
                    label="Technologies"
                    fullWidth
                    size="small"
                    handleChange={(e) => setTechnologies(e.target.value)}
                />
                <SelectBox
                    items={langOptions}
                    label="Language"
                    size="small"
                    fullWidth
                    handleChange={(e) => setLanguage(e.target.value)}
                />

            </>
        );
    };

    const tableFilters = () => {
        return (
            <>
                <MultiSelect
                    columnsList={columns}
                    setColumnsList={(e) => {
                        setColumns(e);
                        setToggler(!toggler);
                    }}
                />
                <SelectBox
                    label="Shown"
                    size="small"
                    fullWidth
                    items={rowsOption}
                    handleChange={(e) => setPerPage(e.target.value)}
                    initValue={perPage}
                />
            </>
        )
    }

    const printTh = () => {
        return (
            <>
                <TableCell width="20px">
                </TableCell>
                {columns.map((v, _) => {
                    if (!v.show) return <></>
                    return (<Fragment key={v.id}>
                        {v.type === 'simple_label' &&
                            <TableCell>
                                {v.label}
                            </TableCell>
                        }
                        {v.type === 'order_label' &&
                            <TableCell>
                                <OrderDataBtn handleBtn={setOrderBy} selected={orderBy.name} value={v.value} title={v.label} />
                            </TableCell>
                        }
                    </Fragment>);
                })}
                <TableCell>
                    Actions
                </TableCell>
            </>
        );
    };


    return (
        <LibraryLayout>
            <Box>
                <FilterWrapper
                    isApplied={IsFilterApply}
                    filters={myFilters()}
                    btn={(search || language || technologies) !== '' && (
                        <Button
                            variant="contained"
                            sx={{ borderRadius: "25px", textTransform: "none", width: { md: "fit-content", xs: "100%" } }}
                            onClick={applyFilters}
                        >
                            Filter
                        </Button>
                    )}
                    tableFilters={tableFilters()}
                    clearFilters={clearFilters}
                />
                <Box>
                    {records?.last_page > 1 && (
                        <Box component="div" sx={{ mb: 3 }}>
                            <UsePagination
                                total={records?.total}
                                perPage={records?.per_page}
                                page={records?.current_page}
                                setPage={setPage}
                                key={records?.last_page}
                            />
                        </Box>
                    )}
                    <TableWrapper
                        thContent={printTh()}
                        spanTd={columns.length + 2}
                        isLoading={isLoading}
                        isContent={records?.data.length}
                    >
                        {records?.data.map((v, i) => {
                            let rowNum = (records?.current_page - 1) * records?.per_page + i + 1;
                            return (
                                <TableRow key={i}>
                                    <TableCell sx={{ textAlign: "center" }}>{rowNum}</TableCell>
                                    {columns[0].show &&
                                        <TableCell>
                                            {v?.title || '-'}
                                        </TableCell>
                                    }
                                    {columns[1].show &&
                                        <TableCell>
                                            -
                                        </TableCell>
                                    }
                                    <TableCell>
                                        <Tooltip title='Edit' placement='top'>
                                            <IconButton
                                                onClick={() => navigate(`/library/project-template/${v.id}`, { id: v.id })}
                                                color='info'
                                            >
                                                <CreateIcon />
                                            </IconButton>
                                        </Tooltip>
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                    </TableWrapper>
                    {records?.last_page > 1 && (
                        <Box component="div" sx={{ mt: 4 }}>
                            <UsePagination
                                total={records?.total}
                                perPage={records?.per_page}
                                page={records?.current_page}
                                setPage={setPage}
                                key={records?.last_page}
                            />
                        </Box>
                    )}
                </Box>
            </Box>
            {openModal ? (
                <CustomModal
                    width="600px"
                    children={<TemplateForm handleClose={() => setOpenModal(false)} getData={getData} />}
                    handleClose={() => setOpenModal(false)}
                />
            ) : (
                <AddProjectBtn
                    tooltip='Create project template'
                    handleClick={() => setOpenModal(true)} />
            )}
        </LibraryLayout>
    )
}

const rowsOption = [
    { label: "25 Rows", value: "25" },
    { label: "50 Rows", value: "50" },
    { label: "75 Rows", value: "75" },
    { label: "100 Rows", value: "100" },
];

const langOptions = [
    { label: 'Deutsch (CH)', value: 'dutch' },
    { label: 'English', value: 'english' }
];

const techOptions = [
    { label: 'Battery Storage', value: 'battery_storage' },
    { label: 'Energy Management', value: 'energy_management' },
    { label: 'Photovoltaic', value: 'photovoltaic' }
];

const _columns = [
    {
        id: 1,
        label: "Name",
        value: "title",
        show: true,
        type: 'order_label'
    },
    {
        id: 2,
        label: "Language",
        value: "language",
        show: true,
        type: 'simple_label'
    },
];